function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #000;\n        stroke-width: .04px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "g2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1",
  className: "cls-2",
  d: "m0,5.66h12.31v12.31H0V5.66Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path2",
  d: "m6.86,10.43c-2.03,0-3.68-1.64-3.68-3.67,0-2.03,1.64-3.68,3.67-3.68,0,0,0,0,0,0,2.03,0,3.68,1.65,3.67,3.68,0,2.03-1.65,3.67-3.67,3.67Zm0-1.23c1.35,0,2.45-1.1,2.45-2.45s-1.1-2.45-2.45-2.45-2.45,1.1-2.45,2.45,1.1,2.45,2.45,2.45ZM6.25.01h1.23v1.84h-1.23V.01Zm0,11.64h1.23v1.84h-1.23v-1.84ZM1.67,2.42l.87-.87,1.3,1.3-.87.87-1.3-1.3h0Zm8.23,8.23l.87-.87,1.3,1.3-.87.87-1.3-1.3Zm1.3-9.1l.87.87-1.3,1.3-.87-.87,1.3-1.3h0ZM2.97,9.79l.87.87-1.3,1.3-.87-.87,1.3-1.3Zm10.64-3.65v1.23h-1.84v-1.23h1.84Zm-11.64,0v1.23H.12v-1.23h1.84Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "g3"
}, /*#__PURE__*/React.createElement("g", {
  id: "g1"
}, /*#__PURE__*/React.createElement("circle", {
  id: "circle1",
  cx: 19.76,
  cy: 8.88,
  r: 1.53
}), /*#__PURE__*/React.createElement("path", {
  id: "path1-5",
  d: "m23.47,10.99c-.38-.19-.84-.06-1.03.33l-.67,1.26-2.95-1.86c-.11-.08-.25-.11-.4-.11h-3.26c-.29,0-.54.15-.67.4l-1.24,2.3c-.21.36-.06.84.31,1.03.11.06.25.1.36.1.27,0,.54-.15.67-.4l1.03-1.9h1.13l-3.39,6.32h-3.18c-.42,0-.77.34-.77.77s.34.77.77.77h3.64c.29,0,.54-.15.67-.4l1.34-2.47,2.2,2.05-.17,3.85c-.04.42.29.79.71.8h.04c.4,0,.75-.33.77-.73l.19-4.21c.02-.23-.08-.44-.25-.59l-1.86-1.72,1.95-3.64,2.22,1.4c.17.11.4.15.61.1s.38-.19.48-.38l1.05-2.01c.21-.36.08-.82-.31-1.03Z"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path3",
  className: "cls-1",
  d: "m6.22,10.35c-1.73-.33-3.01-1.85-3.01-3.58,0-1.67,1.14-3.13,2.78-3.56.48-.13,1.2-.13,1.7,0,1.3.32,2.27,1.24,2.68,2.56.09.28.1.41.1,1.01,0,.67,0,.7-.15,1.11-.51,1.48-1.79,2.45-3.32,2.51-.3.01-.57,0-.79-.04Zm1.28-1.21c1.25-.33,2.05-1.62,1.78-2.89-.24-1.11-1.14-1.88-2.27-1.95-1.16-.06-2.13.6-2.5,1.71-.13.38-.13,1.06,0,1.47.25.8.92,1.44,1.71,1.66.29.08.98.08,1.29,0Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "path4",
  className: "cls-1",
  d: "m10.36,3.27l-.42-.42.63-.62.63-.62.42.42.42.42-.63.63-.63.63-.42-.42Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "path5",
  className: "cls-1",
  d: "m6.28.93V.02h1.16v1.81h-1.16v-.91Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path6",
  className: "cls-1",
  d: "m18.35,23.75c-.16-.06-.32-.21-.4-.39-.08-.19-.08-.21,0-2.2l.09-2.01-.14-.14c-.8-.77-2.07-1.92-2.1-1.9-.02.02-.34.61-.73,1.31-.61,1.12-.72,1.3-.88,1.41l-.18.13h-1.91c-1.3.02-1.97.01-2.09-.02-.1-.03-.25-.11-.34-.2-.39-.36-.3-.97.19-1.19.16-.07.31-.08,1.84-.08h1.66s1.69-3.15,1.69-3.15c.93-1.73,1.69-3.16,1.69-3.17s-.27-.02-.59-.01h-.59s-.53.98-.53.98c-.29.53-.59,1.02-.66,1.09-.36.33-.9.22-1.13-.23-.16-.32-.14-.39.59-1.75.37-.69.72-1.31.79-1.37.22-.24.24-.24,2.18-.24h1.78l.38.23c.21.13.93.57,1.59.99.66.42,1.21.76,1.21.75,0,0,.17-.31.36-.68.2-.37.4-.71.45-.77.19-.22.56-.28.83-.15.31.15.5.53.4.82-.1.3-1.17,2.29-1.29,2.4-.18.16-.44.23-.64.18-.09-.02-.66-.36-1.28-.75-.61-.39-1.15-.71-1.18-.71-.06,0-2,3.53-1.98,3.62,0,.02.43.43.94.91,1.07,1,1.07,1,1.12,1.17.02.08,0,1.02-.07,2.36-.1,2.13-.11,2.24-.2,2.4-.13.23-.39.38-.64.38-.1,0-.22-.01-.25-.03Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "path7",
  className: "cls-1",
  d: "m19.52,10.36c-.29-.04-.7-.26-.87-.45-.07-.08-.18-.25-.25-.37-.11-.2-.12-.27-.12-.66,0-.41,0-.45.15-.7.49-.9,1.66-1.07,2.38-.35.59.59.59,1.52,0,2.12-.35.35-.8.49-1.29.42Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "path8",
  className: "cls-1",
  d: "m11.8,6.75v-.6h1.77v1.21h-1.77v-.6Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "path9",
  className: "cls-1",
  d: "m2.34,3.05l-.64-.64.41-.41.41-.41.64.64.64.64-.41.41-.41.41-.64-.64Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "path10",
  className: "cls-1",
  d: "m.15,6.75v-.6h1.81v1.21H.15v-.6Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "path11",
  className: "cls-1",
  d: "m2.12,11.5l-.42-.42.63-.62.63-.62.42.42.42.42-.63.63-.63.63-.42-.42Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "path12",
  className: "cls-1",
  d: "m6.28,12.57v-.91h1.16v1.81h-1.16v-.91Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "path13",
  className: "cls-1",
  d: "m10.55,11.27l-.61-.62.41-.41.41-.41.63.62.63.62-.4.4c-.22.22-.41.4-.42.4s-.3-.28-.64-.62Z"
});

const SvgSun = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "svg2",
  viewBox: "0 0 23.88 23.82",
  width: "24px",
  height: "24px",
  ref: svgRef
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSun, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sun.2399c290.svg";
export { ForwardRef as ReactComponent };